import { setConfirm } from "store/actions/appAction";
import { apiDeleteRoles, apiGetPermissions, apiGetRoles } from "api/roleApi";
import ArrowBackIcon from "assets/icons/ArrowBackIcon";
import EditIcon from "assets/icons/EditIcon";
import PlusIcon from "assets/icons/PlusIcon";
import TrashIcon from "assets/icons/TrashIcon";
import BasicButton from "components/BasicInputs/BasicButton";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PermissionsViewButton from "./comps/PermissionsViewButton";

export interface RolesProps {}
export default function Roles(props: RolesProps) {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const store = useSelector((state: any) => state);
  const token = store.businessReducer.business.token;
  const roles: any[] = store.roleReducer.roles;
  const permissions: Permission[] = store.permissionReducer.permissions || [];

  useEffect(() => {
    dispatch(apiGetRoles(token));
  }, [token]);

  function getRolePermissions(roleId: number){
    apiGetPermissions(token, null, dispatch, roleId)
  }

  // const headers = ["عنوان نقش", "تعداد کاربران", "عملیات"];
  const headers = ["عنوان نقش", "مشاهده", "عملیات"];
  return (
    <div>
      <div className="flex items-center justify-between w-full">
        <span className="text-xl text-[#5B5B5C]">مدیریت کاربران</span>
        <div>
          <BasicButton color="disabled" onClick={() => navigate('/settings/userManagement')} className="min-w-[60px] p-0">
            <ArrowBackIcon color="#7D96B8" />
            <span>{"بازگشت"}</span>
          </BasicButton>
        </div>
      </div>

      <div className="flex flex-col gap-4 my-10">
        <div className="flex items-center justify-between border-b border-slate-300">
          {headers.map((x, i) => (
            <span key={i} className="py-4 text-[#576271] w-20 flex justify-center items-center">{x}</span>
          ))}
        </div>
        {roles.map((role, i) => {
          return (
            <div key={i} className="flex items-center justify-between">
              <div className="flex w-20">{role.label}</div>
              {/*<div className="flex items-center justify-center w-20">{2}</div>*/}
              <PermissionsViewButton {...{ role, permissions, getRolePermissions }} />
              <div className="flex items-center justify-center w-20 gap-2">
                {role.BusinessId && (
                  <>
                    <span
                      className="cursor-pointer"
                      onClick={() => {
                        const action: any = apiDeleteRoles(token, role.id, () => {
                          dispatch(apiGetRoles(token));
                        });
                        dispatch(setConfirm("آیا مطمئن هستید ؟", action));
                      }}
                    >
                      <TrashIcon color="#6B7888" />
                    </span>
                    <span className="w-px h-5 bg-slate-300"></span>
                    <span
                      className="cursor-pointer"
                      onClick={() => {
                        navigate(`/roles/${role?.id}`);
                      }}
                    >
                      <EditIcon color="#6B7888" />
                    </span>
                  </>
                )}
              </div>
            </div>
          );
        })}
        <div className="flex justify-center w-full">
          <BasicButton
            variant="contained"
            onClick={() => {
              navigate("/roles/add");
            }}
          >
            <PlusIcon scale={0.7} color="#fff" />
            <span>افزودن نقش جدید</span>
          </BasicButton>
        </div>
      </div>
    </div>
  );
}
